<div class="scroll-container" #container>
  <ul class="scroll-container__list">
    <li class="scroll-container__item" #item *ngFor="let item of list">
      <div >
        <ng-container *ngIf="itemContent; else defaultItemContent">
          <ng-content
            *ngTemplateOutlet="
              itemContent;
              context: {
                $implicit: item
              }"
          ></ng-content>
        </ng-container>
      </div>

    </li>
  </ul>
</div>

<ng-template #defaultItemContent let-item>
  <button class="action">
    item
  </button>
</ng-template>
